
class AppConfig {
    static URL = '';
    static DOMAIN = 'https://tastee.app';

    static lang = 'esMX';

    static SUB_FREE = 'FREE';
    static SUB_BASIC = 'BASIC';
    static SUB_STANDARD = 'STANDARD';
    static SUB_PREMIUM = 'PREMIUM';

    static CURRENCIES = [
        "MXN",
        "USD",
    ]

    static LANG_ES_MX = 'esMX';
    static LANG_EN_US = 'enUS';

    static FREE_TOTAL_ITEMS = 75

    static ANALYTICS_SEQUENCE_SETUP = "SETUP"
    static ANALYTICS_SEQUENCE_SIGNUP = "SIGN_UP"
    static ANALYTICS_SEQUENCE_PUBLIC_MENU = "PUBLIC_MENU"

    static ANALYTICS_SEQUENCE_MENU_CREATOR = "MENU_CREATOR"


    static POLL_ANSWER_DATE_CHECK = "LastPollAnsweredDate"
}


export default AppConfig;